
import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ak from "../images/ak.png"
import Typewriter from 'typewriter-effect'
import './Home.css'
import { HashLink } from 'react-router-hash-link';

const Introduction = () => {
    return (
        <div id='home-about' style={{ marginTop: '100px' }}>
            <Container>
                <Row xs={1} md={2} className="align-items-center">
                    <Col style={{ marginRight: '' }}>
                        <div>
                            <p className="title-color">Hello, This is</p>
                            <h1 className="mb-3">Aktarina Akhi</h1>
                            <div className="typewritter title-color">
                                <Typewriter
                                    options={{
                                        strings: ['Web Developer', 'Programmer'],
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />

                            </div>
                            <p className="mt-3">A self-motivated and enthusiastic web developer with a deep interest in JavaScript. To work in the Software industry with modern web technologies of different local & multinational Software/ IT agencies of Bangladesh and grow rapidly with increasing responsibilities.</p>
                            <div className="my-5">
                                <HashLink to="/home#contact">
                                    <Button className="me-4" variant="outline-success">Get In Touch</Button>{' '}
                                </HashLink>
                            </div>
                        </div>

                    </Col>
                    <Col className="intro-image">
                        <img style={{ width: '50%', marginLeft: '70px' }} src={ak} alt="" />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Introduction;